import React, { useEffect, useState } from 'react';
import { Button } from '@/components';
import { SideBarModal } from '@/components/Modal';

interface RejectPurchaseOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (rejectionReason: string) => void;
  isSubmitting?: boolean;
}

const RejectPurchaseOrderModal: React.FC<RejectPurchaseOrderModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError('Rejection reason is required');
      return;
    }
    onSubmit(reason.trim());
  };

  return (
    <SideBarModal
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      width="md"
      maxHeight="auto"
      header={
        <div>
          <div className="text-base font-semibold text-gray-900">
            Reject Purchase Order
          </div>
          <div className="text-xs text-gray-500">
            Provide a reason for rejecting this purchase order.
          </div>
        </div>
      }
      footer={
        <div className="flex w-full justify-end gap-2">
          <Button variant="white" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Rejecting...' : 'Reject'}
          </Button>
        </div>
      }
      className="max-w-[520px]"
    >
      <div className="px-6 py-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Rejection Reason <span className="text-red-500">*</span>
        </label>
        <textarea
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError('');
          }}
          rows={4}
          placeholder="Explain why this purchase order is being rejected"
          className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </div>
    </SideBarModal>
  );
};

export default RejectPurchaseOrderModal;
